
import BackgroundCategoryListItem from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundCategoryService/BackgroundCategoryListItem";
import { BACKGROUND_CATEGORY_CREATE, BACKGROUND_CATEGORY_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";

@Component
export default class BackgroundCategoriesPage extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  getDataFunc = this.$api.BackgroundCategoryService.getListAsync.bind(
    this.$api.BackgroundCategoryService
  );
  removeFunc = this.$api.BackgroundCategoryService.deleteAsync.bind(
    this.$api.BackgroundCategoryService
  );
  columnNames = ["#", "Название", "Фонов", "", ""];
  createRouteName = BACKGROUND_CATEGORY_CREATE;
  editRouteName = BACKGROUND_CATEGORY_EDIT;

  startDelete(item: BackgroundCategoryListItem) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
